import styled from 'styled-components';

export const Container = styled.div``;

export const Header = styled.div`
  display: flex;
  border-bottom: 1px solid ${(props) => props.theme.config.colors.gray_200};
  padding: 1.6rem 2.4rem;

  h6 {
    ${(props) => props.theme.config.typograph.mico};
    color: ${(props) => props.theme.config.colors.gray};
    margin-bottom: 0.4rem;
  }

  p {
    ${(props) => props.theme.config.typograph.default};
    font-weight: bold;
    color: ${(props) => props.theme.config.colors.text_base};
  }
`;

export const Content = styled.div`
  padding: 1.6rem 2.4rem;
  min-height: 26rem;
`;

export const UsersList = styled.div`
  max-height: 14rem;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 1.2rem;
  padding-top: 1.2rem;
  border-top: 1px solid ${(props) => props.theme.config.colors.gray_200};

  &::-webkit-scrollbar {
    background: ${(props) => props.theme.config.colors.gray_100};
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.config.colors.gray_300};
    border-radius: 8px;
    width: 5px;
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button.user {
    all: unset;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    flex: 1;
    cursor: pointer;

    img,
    div {
      width: 2.4rem;
      height: 2.4rem;
      min-width: 2.4rem;
    }

    span {
      ${(props) => props.theme.config.typograph.default};
      color: ${(props) => props.theme.config.colors.text_base};
    }
  }

  & + div {
    margin-top: 1.6rem;
  }

  &.active {
    background-color: ${(props) => props.theme.config.colors.primary_100};
    padding: 0.8rem;
    border-radius: 4px;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid ${(props) => props.theme.config.colors.gray_200};
  padding: 1.6rem 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Empty = styled.div`
  ${(props) => props.theme.config.typograph.xsmall};
  color: ${(props) => props.theme.config.colors.gray_400};
  height: 12rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1.2rem;
  padding-top: 1.2rem;
  border-top: 1px solid ${(props) => props.theme.config.colors.gray_200};
`;

export const EmptyMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;

  strong {
    ${(props) => props.theme.config.typograph.default};
    color: ${(props) => props.theme.config.colors.secondary};
    font-weight: bold;
  }

  span {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.gray_400};
  }
`;

export const LoadingContainer = styled.div`
  max-height: 16rem;
  overflow: hidden;
  margin-top: 1.6rem;

  .skeleton-container {
    span {
      height: 2.4rem;
    }

    & + .skeleton-container {
      margin-top: 1.6rem;
    }
  }
`;

export const DateInputWrapper = styled.div`
  width: 100%;

  .MuiInputBase-root {
    border: 1px solid ${(props) => props.theme.config.colors.gray_300};
    border-radius: 8px;
    padding: 0.8rem 1.2rem;
    width: 100%;

    &:hover {
      border-color: ${(props) => props.theme.config.colors.gray_400};
    }

    &.Mui-focused {
      border-color: ${(props) => props.theme.config.colors.primary};
    }

    input {
      ${(props) => props.theme.config.typograph.default};
      padding: 0;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export const DateRangeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.6rem;

  span {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.gray_400};
  }
`;

export const DateInputSmall = styled.div`
  flex: 1;

  .MuiInputBase-root {
    border: 1px solid ${(props) => props.theme.config.colors.gray_300};
    border-radius: 8px;
    padding: 0.6rem 1rem;
    width: 100%;

    &:hover {
      border-color: ${(props) => props.theme.config.colors.gray_400};
    }

    &.Mui-focused {
      border-color: ${(props) => props.theme.config.colors.primary};
    }

    input {
      ${(props) => props.theme.config.typograph.xsmall};
      padding: 0;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export const TimeRangeLabel = styled.div`
  ${(props) => props.theme.config.typograph.xsmall};
  color: ${(props) => props.theme.config.colors.gray_400};
  margin-bottom: 0.8rem;
`;

export const DaysSelectRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.6rem;
`;

export const TestSelectLabel = styled.div`
  ${(props) => props.theme.config.typograph.xsmall};
  color: ${(props) => props.theme.config.colors.gray_400};
  margin-bottom: 0.8rem;
`;

export const UserSearchSection = styled.div`
  margin-top: 1.6rem;
  padding: 1.2rem;
  border: 1px solid ${(props) => props.theme.config.colors.gray_200};
  border-radius: 8px;
`;

export const HistoryLabel = styled.span`
  display: block;
  ${(props) => props.theme.config.typograph.mico};
  color: ${(props) => props.theme.config.colors.gray_400};
  text-transform: uppercase;
  margin-top: 1.2rem;
  letter-spacing: 0.05em;
`;

export const SelectWrapper = styled.div`
  flex: 1;
`;

export const SelectedUsersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 1.2rem;
  padding-top: 1.2rem;
  border-top: 1px solid ${(props) => props.theme.config.colors.gray_200};
  max-height: 8rem;
  overflow-y: auto;

  &::-webkit-scrollbar {
    background: ${(props) => props.theme.config.colors.gray_100};
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.config.colors.gray_300};
    border-radius: 8px;
    width: 5px;
  }
`;

export const SelectedUserTag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: ${(props) => props.theme.config.colors.white};
  border: 1px solid ${(props) => props.theme.config.colors.gray_300};
  border-radius: 16px;
  padding: 0.4rem 0.8rem;

  img,
  .avatar-placeholder {
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
    border-radius: 50%;
  }

  span {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.text_base};
    max-width: 10rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  button {
    all: unset;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.2rem;

    svg {
      width: 1.2rem;
      height: 1.2rem;
      color: ${(props) => props.theme.config.colors.gray_400};
    }

    &:hover svg {
      color: ${(props) => props.theme.config.colors.danger};
    }
  }
`;

export const UserItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.config.colors.gray_100};
  }

  > img,
  > div:first-child {
    width: 3.2rem;
    height: 3.2rem;
    min-width: 3.2rem;
  }

  & + div {
    border-top: 1px solid ${(props) => props.theme.config.colors.gray_100};
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .name {
    ${(props) => props.theme.config.typograph.default};
    color: ${(props) => props.theme.config.colors.text_base};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .email {
    ${(props) => props.theme.config.typograph.xsmall};
    color: ${(props) => props.theme.config.colors.gray_400};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
